<template>
    <div class="mb-10 setup">
        <v-dialog v-model="videodialog" max-width="800px" role="dialog" aria-modal="true" aria-labelledby="tutorial-video-title">
            <v-card v-focus-trap="videodialog">
                <v-card-title>
                    <h2 id="tutorial-video-title" class="sr-only">Content Suite Tutorial</h2>
                    <v-btn class="mt-2" @click="videodialog = false" right absolute icon :aria-label="'Close dialog'"> <v-icon aria-hidden="true">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="mt-4">
                    <div class="video-container">
                        <iframe
                            @click:esc="videodialog = false"
                            data-focus-first
                            tabindex="0"
                            style="border-radius: 10px"
                            width="560"
                            height="315"
                            :src="videoUrl"
                            title="Content Suite Tutorial"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </v-card-text>
                <v-card-action class="d-flex">
                    <v-btn class="ml-auto mb-2 mr-2" rounded color="primary" @click="videodialog = false">close</v-btn>
                </v-card-action>
            </v-card>
        </v-dialog>
        <v-snackbar top v-model="notification.show" :color="notification.color" role="status" aria-live="polite" aria-atomic="true" :aria-describedby="'snack-text'">
            <v-icon aria-hidden="true">{{ notification.icon }}</v-icon>
            <span id="snack-text" class="font-weight-bold pl-2">
                {{ notification.message }}
            </span>
        </v-snackbar>
        <v-row>
            <v-col xl="6" lg="8" md="8" sm="12">
                <v-slide-x-transition>
                    <v-card class="mb-5 rounded_card details_card quaroshadow" v-if="project._id" role="region" :aria-labelledby="'proj-section-title'">
                        <v-row no-gutters>
                            <div class="title_area">
                                <div id="proj-section-title" class="titlelbl white--text">PROJECT</div>
                                <div class="cs_p_title">{{ project.title }}</div>

                                <div class="mkwlbl">TOPIC</div>
                                <div class="cs_p_kw">{{ project.main_keyword }}</div>
                            </div>

                            <div class="details_area">
                                <div class="setup_progress_bar">
                                    <v-progress-linear
                                        height="7px"
                                        rounded
                                        :value="(e1 / 6) * 100"
                                        role="progressbar"
                                        aria-label="Setup progress"
                                        :aria-valuemin="0"
                                        :aria-valuemax="100"
                                        :aria-valuenow="Math.round((e1 / 6) * 100)"
                                        :aria-describedby="'setup-progress-text'" />
                                    <span id="setup-progress-text" class="setup_progress_bar_text" aria-live="polite"> Step {{ e1 }}/ 6 </span>
                                </div>

                                <div class="my-auto">
                                    <div class="titlelbl">URL</div>

                                    <div class="cs_url mb-3" v-if="project.url && !url_loading">
                                        {{ project.url }}
                                        <v-btn
                                            v-if="edit"
                                            icon
                                            small
                                            color="primary"
                                            class="ml-1"
                                            type="button"
                                            aria-label="Edit URL"
                                            @click="
                                                addURLDialog.id = project._id
                                                addURLDialog.show = true
                                                addURLDialog.url = project.url
                                            ">
                                            <v-icon aria-hidden="true" small>mdi-pencil</v-icon>
                                        </v-btn>
                                    </div>

                                    <div v-else-if="url_loading" class="mb-3">
                                        <v-progress-circular indeterminate color="primary" size="16" width="2" aria-label="Loading URL" role="status" />
                                    </div>

                                    <div v-else class="mb-3">
                                        <v-btn
                                            @click="
                                                addURLDialog.id = project._id
                                                addURLDialog.show = true
                                            "
                                            class="px-1"
                                            x-small
                                            outlined
                                            color="primary"
                                            type="button"
                                            aria-label="Add URL">
                                            <v-icon class="mr-1" x-small aria-hidden="true">mdi-plus-circle-outline</v-icon>
                                            add url
                                        </v-btn>
                                    </div>

                                    <div class="titlelbl mb-1">KEYWORDS</div>
                                    <div class="cs_topics mb-2" v-if="selectedTopics.length">
                                        <span v-for="(topic, index) in selectedTopics[0].keywords" :key="index">
                                            <v-chip v-if="index < 5" class="white--text mr-2 mb-1" :color="colors[index]">
                                                {{ topic.keyword }}
                                            </v-chip>

                                            <!-- „+ X more“ – per Tastatur fokussierbar -->
                                            <v-tooltip max-width="650" color="" top open-on-focus>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-chip v-on="on" v-bind="attrs" v-if="index == 5" tabindex="0" :aria-label="'Show ' + (selectedTopics[0].keywords.length - 5) + ' more keywords'">
                                                        {{ "+ " + (selectedTopics[0].keywords.length - 5) + " more" }}
                                                    </v-chip>
                                                </template>
                                                <div>
                                                    <span v-for="(variant, vIndex) in selectedTopics[0].keywords" :key="'more-' + vIndex">
                                                        <v-chip v-if="vIndex > 4" style="background-color: white !important" outlined color="primary" class="ma-1 qchip">
                                                            {{ variant.keyword }}
                                                        </v-chip>
                                                    </span>
                                                </div>
                                            </v-tooltip>
                                        </span>
                                    </div>
                                    <div class="cs_topics mb-3" v-else aria-live="polite">{{ selectedTopics.length }} selected</div>

                                    <div class="titlelbl">COMPETITORS</div>
                                    <div class="keywordcount mb-3">{{ selectedCompetitors.length }} selected</div>

                                    <div class="titlelbl">TERMS</div>
                                    <div class="keywordcount mb-3">{{ selectedKeywords.length }} selected</div>
                                </div>
                            </div>
                        </v-row>
                    </v-card>
                </v-slide-x-transition>
            </v-col>
        </v-row>
        <v-row>
            <v-btn rounded color="black" class="pl-2 ml-auto mb-2 mr-3 white--text" small @click="videodialog = true">
                <v-icon small class="mr-1">mdi-video</v-icon>
                tutorial</v-btn
            >
        </v-row>
        <v-stepper rounded v-model="e1" alt-labels non-linear class="rounded_card quaroshadow" aria-label="Content project setup steps">
            <!-- Header ist eine Liste, Steps sind Listitems (nicht interaktiv) -->
            <v-stepper-header elevation-0 role="list" aria-label="Steps">
                <v-stepper-step :complete="e1 > 1" step="1" :id="'step-header-1'" role="listitem" :editable="false" :aria-current="e1 === 1 ? 'step' : null">Setup</v-stepper-step>

                <v-divider v-if="!edit"></v-divider>

                <v-stepper-step v-if="!edit" :complete="e1 > 2" step="2" :id="'step-header-2'" role="listitem" :editable="false" :aria-current="e1 === 2 ? 'step' : null">Select Topic</v-stepper-step>

                <v-divider v-if="!edit && !project.setup.fastmode"></v-divider>

                <v-stepper-step v-if="!edit && !project.setup.fastmode" :complete="e1 > 3" step="3" :id="'step-header-3'" role="listitem" :editable="false" :aria-current="e1 === 3 ? 'step' : null"
                    ><span style="white-space: nowrap">Select Competitors</span></v-stepper-step
                >

                <v-divider v-if="!project.setup.fastmode"></v-divider>

                <v-stepper-step v-if="!project.setup.fastmode" :complete="e1 > 4" step="4" :id="'step-header-4'" role="listitem" :editable="false" :aria-current="e1 === 4 ? 'step' : null"
                    >Select Terms</v-stepper-step
                >

                <v-divider v-if="!project.setup.fastmode"></v-divider>

                <v-stepper-step v-if="!project.setup.fastmode" :complete="e1 > 5" step="5" :id="'step-header-5'" role="listitem" :editable="false" :aria-current="e1 === 5 ? 'step' : null"
                    >Select Questions</v-stepper-step
                >

                <v-divider v-if="!project.setup.fastmode"></v-divider>

                <v-stepper-step v-if="!project.setup.fastmode" :complete="e1 > 6" step="6" :id="'step-header-6'" role="listitem" :editable="false" :aria-current="e1 === 6 ? 'step' : null"
                    >Settings</v-stepper-step
                >
            </v-stepper-header>

            <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1" :id="'step-panel-1'" role="region" :aria-labelledby="'step-header-1'">
                    <CreateProject :project="project" :edit="edit"></CreateProject>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn color="primary" @click="createProject" :disabled="create_button_disabled">Continue</v-btn>
                    </v-row>
                </v-stepper-content>

                <!-- Step 2 -->
                <v-stepper-content step="2" v-if="!edit" :id="'step-panel-2'" role="region" :aria-labelledby="'step-header-2'">
                    <SelectTopics
                        :project="project"
                        :loading="addTopicsLoading"
                        :statusNotification="statusNotification"
                        :demo_project="demo_project"
                        @retryProcess="retryProcess"
                        @update="quickUpdate"></SelectTopics>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            class="mr-2"
                            :disabled="project.setup.loading"
                            @click="
                                e1--
                                trackEvent('CS - Setup', 'Back - Step ' + project.setup.step, '', '')
                            "
                            >Back</v-btn
                        >
                        <v-btn
                            :disabled="project.setup.loading"
                            color="primary"
                            @click="
                                updateProject(3)
                                trackEvent('CS - Setup', 'Continue - Step ' + project.setup.step, '', '')
                            "
                            >Continue</v-btn
                        >
                    </v-row>
                </v-stepper-content>

                <!-- Step 3 (normal) -->
                <v-stepper-content step="3" v-if="!edit && !project.setup.fastmode" :id="'step-panel-3'" role="region" :aria-labelledby="'step-header-3'">
                    <select-competitors
                        :loading="addCompetitorsLoading"
                        :url_loading="url_loading"
                        :project="project"
                        :statusNotification="statusNotification"
                        @retryProcess="retryProcess"></select-competitors>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            :disabled="project.setup.loading"
                            class="mr-2"
                            @click="
                                e1--
                                trackEvent('CS - Setup', 'Back - Step ' + project.setup.step, '', '')
                            "
                            >Back</v-btn
                        >
                        <v-btn
                            :disabled="project.setup.loading"
                            color="primary"
                            @click="
                                updateProject(4)
                                trackEvent('CS - Setup', 'Continue - Step ' + project.setup.step, '', '')
                            "
                            >Continue</v-btn
                        >
                    </v-row>
                </v-stepper-content>

                <!-- Step 3 (fastmode loader) -->
                <v-stepper-content
                    step="3"
                    v-if="!edit && project.setup.fastmode"
                    :id="'step-panel-3'"
                    role="region"
                    :aria-labelledby="'step-header-3'"
                    aria-live="polite"
                    aria-atomic="true"
                    :aria-busy="true">
                    <div class="loaderwrapper">
                        <v-row class="loaderimg mb-10">
                            <img id="loader" :src="getSrc()" alt="Loading" />
                        </v-row>
                        <v-row class="loaderheading">
                            <span id="fastmode-status" style="font-weight: 300; font-size: 16px" class="mx-auto">
                                {{ statusNotification.message }}
                            </span>
                        </v-row>
                        <v-row class="ma-auto">
                            <v-col>
                                <div id="loaderdiv">
                                    <v-progress-linear
                                        :indeterminate="statusNotification.message ? false : true"
                                        rounded
                                        height="6px"
                                        class="ma-auto"
                                        color="primary"
                                        :value="statusNotification.progress"
                                        role="progressbar"
                                        aria-label="Loading progress"
                                        :aria-describedby="'fastmode-status'"
                                        :aria-valuemin="0"
                                        :aria-valuemax="100"
                                        :aria-valuenow="statusNotification.message ? statusNotification.progress : undefined"
                                        :aria-valuetext="statusNotification.message ? statusNotification.progress + ' percent' : 'Working…'"></v-progress-linear>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-10">
                            <p class="loadersubtext">Note: Based on your selected focus topics, we now identify the most relevant and strongest competitors. This usually only takes a few seconds!</p>
                        </v-row>
                    </div>
                </v-stepper-content>

                <!-- Step 4 -->
                <v-stepper-content step="4" :id="'step-panel-4'" role="region" :aria-labelledby="'step-header-4'">
                    <select-terms
                        @updateKeywords="updateKeywords"
                        @retryProcess="retryProcess"
                        setup
                        :statusNotification="statusNotification"
                        :loading="addKeywordsLoading"
                        :project="project"
                        :topKeywords="topKeywords"></select-terms>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            :disabled="project.setup.loading"
                            class="mr-2"
                            @click="
                                !edit ? e1-- : (e1 = 1)
                                trackEvent('CS - Setup', 'Back - Step ' + project.setup.step, '', '')
                            "
                            >Back</v-btn
                        >
                        <v-btn
                            color="primary"
                            :disabled="project.setup.loading"
                            @click="
                                updateProject(5)
                                trackEvent('CS - Setup', 'Continue - Step ' + project.setup.step, '', '')
                            "
                            >Continue</v-btn
                        >
                    </v-row>
                </v-stepper-content>

                <!-- Step 5 -->
                <v-stepper-content step="5" :id="'step-panel-5'" role="region" :aria-labelledby="'step-header-5'">
                    <SelectQuestions :questions="project.questions" @updateQuestions="updateQuestions" setup></SelectQuestions>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                e1--
                                trackEvent('CS - Setup', 'Back - Step ' + project.setup.step, '', '')
                            "
                            >Back</v-btn
                        >
                        <v-btn
                            color="primary"
                            @click="
                                updateProject(6)
                                trackEvent('CS - Setup', 'Continue - Step ' + project.setup.step, '', '')
                            "
                            >Continue</v-btn
                        >
                    </v-row>
                </v-stepper-content>

                <!-- Step 6 -->
                <v-stepper-content step="6" :id="'step-panel-6'" role="region" :aria-labelledby="'step-header-6'">
                    <SetupSettings :project="project"></SetupSettings>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="mr-2"
                            @click="
                                $router.push('/content-projects')
                                trackEvent('CS - Setup', 'Cancel - Step ' + project.setup.step, '', '')
                            "
                            >Cancel</v-btn
                        >
                        <v-btn
                            :disabled="project.setup.finished && !demo_project"
                            text
                            class="mr-2"
                            @click="
                                e1--
                                trackEvent('CS - Setup', 'Back - Step ' + project.setup.step, '', '')
                            "
                            >Back</v-btn
                        >
                        <v-btn
                            :disabled="project.setup.finished && !demo_project"
                            color="primary"
                            @click="
                                updateProject(7)
                                trackEvent('CS - Setup', 'Finish - Step ' + project.setup.step, '', '')
                            "
                            >finish</v-btn
                        >
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <AddUrlDialogVue
            :show="addURLDialog.show"
            :id="addURLDialog.id"
            :url="addURLDialog.url"
            @started="addedURLNotification()"
            @added="
                fetchProject(project._id)
                this.url_loading = false
            "
            @close="addURLDialog.show = false"
            :setMainURL="true"
            :addLighthouseData="true"></AddUrlDialogVue>
    </div>
</template>

<script>
    import CreateProject from "../../components/content-suite/setup/CreateProject.vue"
    import SelectTopics from "../../components/content-suite/setup/SelectTopics.vue"
    import SelectCompetitors from "../../components/content-suite/setup/SelectCompetitors.vue"
    import SelectTerms from "../../components/content-suite/setup/SelectTerms.vue"
    import SelectQuestions from "../../components/content-suite/setup/SelectQuestions.vue"
    import SetupSettings from "../../components/content-suite/setup/SetupSettings.vue"
    import AddUrlDialogVue from "../../components/content-suite/AddUrlDialog.vue"
    export default {
        components: {
            CreateProject,
            SelectTopics,
            SelectCompetitors,
            SelectTerms,
            SelectQuestions,
            SetupSettings,
            AddUrlDialogVue
        },
        data() {
            return {
                videodialog: false,
                videoUrl: "https://www.youtube.com/embed/6J1xuj3LqPs",
                finishedFastMode: false,
                addURLDialog: {
                    id: null,
                    show: false,
                    url: ""
                },
                edit: false,
                colors: ["cyan darken-3", "purple darken-3", "lime darken-4", "green darken-3", "blue darken-4", "orange darken-3", "red darken-3"],
                statusNotification: { message: "" },
                addKeywordsLoading: false,
                addTopicsLoading: false,
                addCompetitorsLoading: false,
                notification: { show: false },
                url_loading: false,
                project: {
                    shared: true,
                    briefing_shared: true,
                    briefing_shared_extern: false,
                    editor_shared: true,
                    editor_shared_extern: false,
                    editable: true,
                    title: "",
                    url: "",
                    main_keyword: "",
                    topics: [],
                    langloc: { language_code: "de", location_code: "2276" },
                    competitors: [],
                    keywords: 0,
                    device: "mobile",
                    questions: [],
                    setup: {
                        finished: false,
                        step: 1,
                        loading: true,
                        fastmode: false,
                        depth: { depth: 10, label: "Top 10" }
                    },
                    settings: {
                        word_count: 0,
                        term_usage: 75,
                        readability: { id: 4, min: 45, max: 60, text: "normal", color: "amber darken-2" },
                        placement: 10
                    },
                    wdf_version: 2,
                    briefing_description: "",
                    authors: []
                },
                topKeywords: [],
                e1: 1,
                create_button_disabled: false,
                folder: null
            }
        },

        methods: {
            getSrc() {
                if (this.company_id == "1547") {
                    return require("@/assets/quaro-q-obi.svg")
                } else {
                    return require("@/assets/quaro-q.svg")
                }
            },
            async quickUpdate() {
                const url = process.env.VUE_APP_APIURL + "/cs/update"
                let post_data = {
                    company_id: localStorage.company_id,
                    project: this.project
                }
                await this.$helpers.axiosPost(url, post_data)
            },
            async updateQuestions(questions) {
                questions.map((question) => {
                    let index = this.project.questions.findIndex((x) => question.question == x.question)
                    if (index > -1) {
                        this.project.questions[index].selected = question.selected
                    } else {
                        this.project.questions.push(question)
                    }
                })
                const url = process.env.VUE_APP_APIURL + "/cs/update"
                let post_data = {
                    company_id: localStorage.company_id,
                    project: this.project
                }
                await this.$helpers.axiosPost(url, post_data)
                console.log("questions updated!!!!")
                // this.$emit("fetchQuestions")
            },
            retryProcess(step) {
                if (step == 1) {
                    this.addTopics()
                } else if (step == 2) {
                    this.addCompetitors()
                } else if (step == 3) {
                    this.addKeywords()
                }
            },
            trackEvent(component, action, param1, param2) {
                try {
                    this.$matomo.trackEvent(component, action, param1, param2)
                } catch (error) {
                    console.log(error)
                    console.log("matomo blocked")
                }
            },
            /**
             * creates new project in database
             */
            async createProject() {
                try {
                    if (!this.project._id) {
                        if (!this.checkStep(1)) return
                        this.create_button_disabled = true
                        const url = process.env.VUE_APP_APIURL + "/cs/create"
                        this.project.owner = localStorage.username
                        this.project.setup.step = 2
                        let post_data = {
                            company_id: localStorage.company_id,
                            project: this.project,
                            folder: this.folder,
                            owner_id: localStorage.id
                        }
                        let response_data = await this.$helpers.axiosPost(url, post_data)
                        if (response_data.data.error == "no_credits_left") {
                            this.notification = this.$helpers.createNotification("You dont have any credits left. Please contact the support via chat or email!", "mdi-alert-circle-outline", "#FCBA03")
                            this.create_button_disabled = false
                            this.project.setup.step = 1
                            return
                        }
                        if (!response_data.data.created) {
                            this.create_button_disabled = false
                            this.project.setup.step = 1
                            this.notification = this.$helpers.createNotification("A project with this name already exists, please provide another name!", "mdi-alert", "orange darken-2")
                            return
                        }

                        console.log(response_data)
                        this.project = response_data.data.resp

                        this.e1 = 2
                        this.trackEvent("CS - Setup", "Continue - Step " + this.project.setup.step, this.project.title, this.project.main_keyword)
                        this.changeLoading(this.e1)
                        console.log("NO TOPICS - ADD")
                        if (this.project.url) {
                            this.saveURL()
                        }
                        this.addTopics()
                        this.create_button_disabled = false
                        this.$router.replace({ query: { id: response_data.data.resp._id, step: this.e1 } })
                        return
                    }

                    if (this.edit) {
                        this.updateProject(4)
                    } else if (!this.demo_project && !(this.project.topics && this.project.topics.length) && !this.project.setup.loading) {
                        // Über die Public API angelegte Projekte stehen noch ohne Themen auf Schritt 1. Hier wie beim
                        // Anlegen in der App die Themensuche starten, sonst bleibt Schritt 2 leer und es geht nicht weiter.
                        if (!this.checkStep(1)) return
                        this.project.setup.step = 2
                        this.e1 = 2
                        await this.changeLoading(2)
                        if (this.project.url && !this.project.comparissonURL) {
                            this.saveURL()
                        }
                        this.addTopics()
                        this.$router.replace({ query: { id: this.project._id, step: 2 } })
                    } else {
                        this.updateProject(2)
                    }
                } catch (error) {
                    console.log(error)
                    this.notification = this.$helpers.createNotification("There was an error. Please try again or contact the support!", "mdi-alert-circle-outline", "#FCBA03")
                    this.create_button_disabled = false
                    this.project.setup.step = 1
                }
            },
            /**
             * Updates Project Data
             * @param {*} nextstep
             */
            async updateProject(nextstep) {
                if (!this.checkStep(nextstep - 1)) return
                // Update Project

                this.project.setup.step = nextstep

                if (nextstep == 7) {
                    if (!this.project.setup.finished) {
                        this.project.setup.finished = true
                        this.project.competitors_status = "loading"
                        this.addLHData()
                    }
                }
                const url = process.env.VUE_APP_APIURL + "/cs/update"
                let post_data = {
                    company_id: localStorage.company_id,
                    project: this.project
                }
                await this.$helpers.axiosPost(url, post_data)

                // Check action for nextstep
                if (nextstep == 2 && this.demo_project) {
                    setTimeout(() => {
                        this.project.setup.loading = false
                        this.addTopicsLoading = false
                    }, 3000)
                }
                if (nextstep == 2 && !this.project.topics.length && !this.project.setup.loading) {
                    // this.changeLoading(nextstep)
                    // console.log("NO TOPICS - ADD")
                    // if (this.project.url) {
                    //     this.saveURL()
                    // }
                    // this.addTopics()
                } else if (nextstep == 3 && !this.project.setup.loading) {
                    if (!this.demo_project) {
                        this.changeLoading(nextstep)
                        console.log("NO COMPS - ADD")
                        this.addCompetitors()
                    } else {
                        this.addCompetitorsLoading = true
                        this.changeLoading(nextstep)
                        console.log("NO COMPS - ADD")
                        // this.addCompetitors()
                        this.fetchProject(this.project ? this.project._id : this.$route.query.id, true)
                        setTimeout(() => {
                            this.addCompetitorsLoading = false
                            this.project.setup.loading = false
                        }, 3000)
                    }
                } else if (nextstep == 4 && !this.project.setup.loading && !this.edit) {
                    if (this.demo_project) {
                        let selected = this.project.competitors.filter((x) => x.selected)
                        if (!selected.length) {
                            this.notification = this.$helpers.createNotification("Please select at least one competitor!", "mdi-alert", "orange darken-2")
                            return
                        }
                        this.changeLoading(nextstep)
                        this.addKeywordsLoading = true
                        this.fetchKeywords(this.project ? this.project._id : this.$route.query.id)
                        this.fetchProject(this.project ? this.project._id : this.$route.query.id)
                        setTimeout(() => {
                            this.addKeywordsLoading = false
                            this.project.setup.loading = false
                        }, 3000)
                    } else {
                        console.log(this.project.competitors)
                        let selected = this.project.competitors.filter((x) => x.selected)
                        if (!selected.length) {
                            this.notification = this.$helpers.createNotification("Please select at least one competitor!", "mdi-alert", "orange darken-2")
                            return
                        }
                        this.changeLoading(nextstep)
                        console.log("NO TopKeywords - ADD")
                        this.addKeywords()
                    }
                } else if (nextstep == 7) {
                    this.$router.push("/content-projects")
                }
                this.e1 = nextstep
            },
            async saveURL() {
                const url = process.env.VUE_APP_APIURL + "/cs/add/url"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.project._id,
                    url: this.project.url,
                    mainurl: true,
                    addLighthouseData: true,
                    user_id: localStorage.id
                }
                console.log(post_data)
                this.$helpers.axiosPost(url, post_data)
            },
            async changeLoading(nextstep) {
                if (nextstep == 2 || nextstep == 3 || nextstep == 4) {
                    this.project.setup.loading = true

                    const url = process.env.VUE_APP_APIURL + "/cs/update"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project: this.project
                    }
                    await this.$helpers.axiosPost(url, post_data)
                }
            },
            /**
             * Fetches Project Data by id
             * @param {*} id
             */
            async fetchProject(id, setInitialSelection = false) {
                console.log("fetch project")
                const url = process.env.VUE_APP_APIURL + "/cs/get/project"
                let post_data = {
                    company_id: localStorage.company_id,
                    id: id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                this.project = response_data.data.project
                console.log(this.project.setup)
                this.edit = this.demo_project ? false : this.project.setup.finished ? true : false
                if (this.project.setup.loading) {
                    if (this.project.setup.step == 2) {
                        this.addTopicsLoading = true
                    } else if (this.project.setup.step == 3) {
                        this.addCompetitorsLoading = true
                    } else if (this.project.setup.step == 4) {
                        this.addKeywordsLoading = true
                    }
                }
                if (setInitialSelection) {
                    this.project.competitors.map((c) => {
                        let avgpos = c.averagePosition ? c.averagePosition : this.getavgpos(c.positions)
                        c.avgpos = avgpos
                        // c.selected = avgpos <= 20 ? true : false
                    })

                    this.project.competitors.sort(function (a, b) {
                        return a.avgpos - b.avgpos
                    })

                    this.project.competitors.map((c, i) => {
                        c.selected = i < this.project.setup.depth.depth ? true : false
                    })
                    console.log(this.project.competitors)
                    const url = process.env.VUE_APP_APIURL + "/cs/update"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project: this.project
                    }
                    await this.$helpers.axiosPost(url, post_data)
                }
                if (this.e1 == 2 && !this.project.topics.length) {
                    console.log("NO TOPICS - ADD")
                    // this.addTopics()

                    // if (this.project.url) {
                    //     this.saveURL()
                    // }
                }
            },
            /**
             * Fetches and adds topics to Project
             * based on main_keyword
             */
            getavgpos(positions) {
                let sum = 0
                if (positions.length) {
                    this.selectedTopics.map((t) => {
                        let e = positions.find((e) => e.keyword == t.keyword)
                        sum += e ? e.position : 100
                    })
                    let avgpos = sum / this.selectedTopics.length
                    return avgpos.toFixed(1)
                }
                return 100
            },
            async addTopics() {
                this.addTopicsLoading = true
                const url = process.env.VUE_APP_APIURL + "/cs/add/topics"
                let post_data = {
                    company_id: localStorage.company_id,
                    user_id: localStorage.id,
                    project_id: this.project._id,
                    socket_id: this.$socket.id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
            },
            /**
             * Fetches and adds Comps to Project
             * based on selected topics
             */
            async addCompetitors() {
                this.addCompetitorsLoading = true
                const url = process.env.VUE_APP_APIURL + "/cs/add/competitors"
                let post_data = {
                    company_id: localStorage.company_id,
                    user_id: localStorage.id,
                    project: this.project,
                    socket_id: this.$socket.id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)

                // this.project.competitors = response_data.data.competitors
                // this.fetchProject(this.project._id)
                // setTimeout(() => {
                //     this.addCompetitorsLoading = false
                // }, 1000)
                // console.log(response_data.data)
            },
            /**
             * extracts Comps Website Conten and identifies Keywords
             * saves Keywords to project
             */
            async addKeywords() {
                this.addKeywordsLoading = true
                const url = process.env.VUE_APP_APIURL + "/cs/add/keywords"
                let post_data = {
                    company_id: localStorage.company_id,
                    user_id: localStorage.id,
                    project: this.project,
                    socket_id: this.$socket.id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
            },
            async processMonitoringComps() {
                this.addCompetitorsLoading = true
                const url = process.env.VUE_APP_APIURL + "/cs/process/monitoring/comps"
                let post_data = {
                    company_id: localStorage.company_id,
                    user_id: localStorage.id,
                    project_id: this.$route.query.id,
                    socket_id: this.$socket.id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
            },
            async addLHData() {
                const url = process.env.VUE_APP_APIURL + "/cs/add/lh-report"
                let post_data = {
                    company_id: localStorage.company_id,
                    project: this.project,
                    socket_id: this.$socket.id
                }
                await this.$helpers.axiosPost(url, post_data)
            },
            async updateKeywords(keywords) {
                const url = process.env.VUE_APP_APIURL + "/cs/update/keywords"
                let post_data = {
                    company_id: localStorage.company_id,
                    user_id: localStorage.id,
                    keywords: keywords,
                    project_id: this.project._id
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
            },
            /**
             * id exists if reload happens while in setup
             * @param {*} id
             */
            async fetchKeywords(id) {
                const url = process.env.VUE_APP_APIURL + "/cs/get/keywords"
                if (id) {
                    let post_data = {
                        company_id: localStorage.company_id,
                        user_id: localStorage.id,
                        project_id: id ? id : this.project._id
                    }
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    console.log(response_data.data)
                    this.topKeywords = response_data.data.keywords
                } else {
                    console.log("no id")
                }
            },

            checkStep(step) {
                console.log("checkstep", step)
                if (step == 1) {
                    if (this.project.title.length < 3) {
                        this.notification = this.$helpers.createNotification("Please provide a project title!", "mdi-alert", "orange darken-2")
                        return false
                    }
                    if (!this.project.main_keyword || this.project.main_keyword.length < 2) {
                        this.notification = this.$helpers.createNotification("Please provide a main keyword!", "mdi-alert", "orange darken-2")
                        return false
                    }
                    if (this.project.url) {
                        try {
                            let url = new URL(this.project.url)
                        } catch (error) {
                            this.notification = this.$helpers.createNotification("Please enter a complete and accurate website URL! (including https://)", "mdi-alert", "orange darken-2")
                            return false
                        }
                    }
                    return true
                } else if (step == 2) {
                    console.log("selected", this.selectedTopics)
                    if (this.selectedTopics.length < 1) {
                        this.notification = this.$helpers.createNotification("Please provide at least one topic!", "mdi-alert", "orange darken-2")
                        return false
                    }
                    return true
                } else if (step == 4) {
                    if (this.selectedKeywords.length < 1) {
                        this.notification = this.$helpers.createNotification("Please select at least 1 Keyword!", "mdi-alert", "orange darken-2")
                        return false
                    }
                    return true
                } else if (step == 5) {
                    // if (this.selectedQuestions.length < 4) {
                    //     this.notification = this.$helpers.createNotification("Please select at least 4 questions!", "mdi-alert", "orange darken-2")
                    //     return false
                    // }
                    return true
                } else {
                    return true
                }
            },
            addedURLNotification() {
                this.addURLDialog.show = false
                this.url_loading = true
                this.notification = this.$helpers.createNotification("The URL has been added! All data will be fetched within the next seconds.", "mdi-check-circle-outline", "primary")
            }
        },
        computed: {
            selectedCompetitors() {
                return this.project.competitors.filter((comp) => comp.selected)
            },
            selectedKeywords() {
                return this.topKeywords.filter((keyword) => keyword.selected)
            },
            selectedTopics() {
                return this.project.topics.filter((topic) => topic.selected)
            },
            selectedQuestions() {
                return this.project.questions.filter((question) => question.selected)
            },
            demo_project() {
                return this.project._id == "674db4378a47311bab30cb2e" ? true : false
            },
            company_id() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (!vm.$route.query.id) {
                    console.log("hiiii")
                    vm.$forceUpdate()
                    vm.project = {
                        shared: true,
                        briefing_shared: true,
                        briefing_shared_extern: false,
                        editor_shared: true,
                        editor_shared_extern: false,
                        editable: true,
                        // Vorbelegung aus dem Opportunities-Tab der AI Suite (?keyword=…&title=…);
                        // ohne Parameter bleibt es beim leeren Formular.
                        title: typeof vm.$route.query.title === "string" ? vm.$route.query.title.slice(0, 120) : "",
                        url: "",
                        main_keyword: typeof vm.$route.query.keyword === "string" ? vm.$route.query.keyword.slice(0, 120) : "",
                        topics: [],
                        langloc: { language_code: "de", location_code: "2276" },
                        competitors: [],
                        keywords: 0,
                        device: "mobile",
                        questions: [],
                        setup: {
                            finished: false,
                            step: 1,
                            loading: true,
                            fastmode: false,
                            depth: { depth: 10, label: "Top 10" }
                        },
                        settings: {
                            word_count: 0,
                            term_usage: 75,
                            readability: { id: 4, min: 45, max: 60, text: "normal", color: "amber darken-2" },
                            placement: 10
                        },
                        wdf_version: 2,
                        briefing_description: ""
                    }
                    vm.e1 = 1
                }
            })
        },
        updated() {
            console.log("STEP:   ", this.e1)
        },
        mounted() {
            console.log(this.$socket.id)
            this.$router.onReady(() => {
                if (this.$route.query.id) {
                    console.log(this.$route.query.id)
                    this.fetchProject(this.$route.query.id)
                    this.fetchKeywords(this.$route.query.id)
                }
                if (this.$route.query.step) {
                    this.e1 = this.$route.query.step
                }
                if (this.$route.query.ms) {
                    console.log("send from moniotring")
                    this.processMonitoringComps()
                }
                if (this.$route.query.folder) {
                    // folder
                    this.folder = this.$route.query.folder
                    console.log("FOLDER FOUND")
                }
                console.log(this.e1)
            })
            this.$socket.on("getCSNotification", (data) => {
                this.statusNotification = data
                if (data.type == "cs_topics_creation_finished") {
                    console.log(this.project)
                    this.fetchProject(this.project ? this.project._id : this.$route.query.id)
                    this.trackEvent("CS - Setup", data.type, "", "")
                    setTimeout(() => {
                        this.addTopicsLoading = false
                    }, 1000)
                } else if (data.type == "cs_competitors_added") {
                    console.log("cs_competitors_added")
                    const setInitialSelection = true
                    this.fetchProject(this.project ? this.project._id : this.$route.query.id, setInitialSelection)
                    this.trackEvent("CS - Setup", data.type, "", "")
                    setTimeout(() => {
                        this.addCompetitorsLoading = false
                    }, 1000)
                } else if (data.type == "cs_creation_finished") {
                    if (data.data && data.data.finishedFastMode) {
                        this.finishedFastMode = true
                        this.$router.push("/content-editor/" + this.project._id)
                    }
                    this.fetchKeywords(this.project ? this.project._id : this.$route.query.id)
                    this.fetchProject(this.project ? this.project._id : this.$route.query.id)
                    this.trackEvent("CS - Setup", data.type, "", "")
                    this.addKeywordsLoading = false
                }
                //  else if (data.type == "error") {
                //     this.retry_button = true
                // }

                // sendNotification(socket_id, 100, "cs_creation_finished", "Finished")
            })
            this.$socket.on("csAddUrl", (data) => {
                console.log("ADD-")
                if (data.url_updated) {
                    this.fetchProject(this.project ? this.project._id : this.$route.query.id)
                    this.url_loading = false
                } else {
                    this.notification = this.$helpers.createNotification("Something went wrong adding your URL! Please try again or contact support.", "mdi-alert", "orange darken-2")
                    this.url_loading = false
                }
                this.trackEvent("CS - Setup", "url updated", data.url_updated, "")
            })
        }
    }
</script>

<style scoped>
    .title_area {
        display: block;
        padding: 20px;
        background-color: var(--v-primary-base);
        border-radius: 10px 0 0 10px;
        color: white;
        width: 25%;
    }
    .details_area {
        display: flex;
        padding: 20px;
        width: 75%;
    }
    .setup_progress_bar {
        width: 20%;
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .setup_progress_bar_text {
        font-size: 9px;
        position: absolute;
        right: 0px;
        top: 10px;
        color: rgb(157, 157, 157);
        align-items: center;
        margin-left: auto;
    }
    .titlelbl {
        font-size: 10px;
    }
    .mkwlbl {
        font-size: 10px;
        margin-top: 15px;
    }
    .cs_p_title {
        font-size: 20px;
    }
    .cs_p_kw {
        font-size: 20px;
    }
    .setup {
        padding-top: 35px;
        padding-left: 100px;
        padding-right: 100px;
        max-width: 1920px;
        margin-left: auto;
        margin-right: auto;
    }
    .v-stepper__header {
        box-shadow: none !important;
    }
    .loaderwrapper {
        padding: 50px;
    }
    .loadersubtext {
        text-align: center;
    }
    .loaderimg {
        margin: auto;
    }
    #loader {
        margin: auto;
    }
    .video-container {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 Ratio */
        height: 0;
        overflow: hidden;
    }

    .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
